<template lang="pug">
.item_card_judge
	.image_container
		.image(
			v-bind:style='{ backgroundImage: "url(" + require(`@/${item.image}`) + ")" }'
		)
			.deco
	.text
		h2.title {{ item.name }}
		template(v-if='$i18n.locale === "en"')
			h4.desc.english(v-html='item.desc_en')
		template(v-else)
			h4.desc(v-html='item.desc')
</template>

<script>
export default {
	props: ['item'],
};
</script>

<style lang="stylus">
.item_card_judge
	display: flex
	flex-wrap: wrap
	background-color: $color_dark
	border-radius: 15px
	border: 1px solid #082448
	margin-bottom: 1rem
	&.special_judge
		background-color: transparent
		border: none
	.image_container
		flex-basis: 250px
		height: 400px
		position: relative
		&:after
			content: ''
			display: block
			padding-top: 100%
		.image
			position: absolute
			width: 100%
			height: 100%
			background-size: cover
			background-position: center top
			border-radius: 15px
			overflow: hidden
			.deco
				position: relative
				height: 100%
				&:after
					content: ''
					position: absolute
					width: 100%
					height: 100%
					left: 0
					border-radius: 15px 0 0 15px
					background: linear-gradient(180deg, rgba(11, 46, 91, 0) 78.85%, #0B2E5B 100%), linear-gradient(270deg, #0B2E5B 0%, rgba(11, 46, 91, 0) 46.18%)
	.text
		padding: 1.25rem 2.5rem
		flex: 1
		.title
			-webkit-line-clamp: 2
			font-size: 1.125rem
			font-weight: 500
			line-height: 48px
			text-align: justify
			margin-bottom: 25px
			color: white
		.desc
			color: white
			text-align: justify
			line-height: 2
			&.english
				font-size: 14px !important
				line-height: 1.8
				color: $color_light
	@media screen and (max-width: $screen-sm-max)
		.image_container
			flex-basis: 100%
			height: 500px
			.image
				border-radius: 15px 15px 0 0
				&:after
					background: linear-gradient(180deg, rgba(11, 46, 91, 0) 50%, #0B2E5B 100%)
				.deco
					&:after
						background: linear-gradient(0.92deg, #0B2E5B 1.04%, rgba(11, 46, 91, 0) 50.26%)
						border-radius: 15px 15px 0 0
						bottom: -1px
		.text
			padding: 24px
			.title
				margin-bottom: 24px
</style>
